import { API_URL } from '../../environment';
import { ducksActionCreator } from '../ducksHelpers';

export const blockedSlotsSettings = {
  stateName: 'blockedSlots',
  dataType: 'array',
  actions: {
    fetch: 'ducks/schedule/FETCH_BLOCKED_SLOTS',
  },
};

// Action Creators
export function fetchBlockedSlots(start, end, callback = () => {}, errorCallback = () => {}) {
  return ducksActionCreator(
    blockedSlotsSettings.actions.fetch,
    'get',
    `${API_URL}/practice/blocked_slots?start=${start.utc().format()}&end=${end.utc().format()}`,
    {},
    true,
    callback,
    errorCallback,
  );
}
